var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Inset, Stack } from "syf-component-library/ui/spacing";
import CreditAffectsTitle from "./subcomponents";
import VantageTrans from "../../../atoms/VantageTrans";
import TipAccordion from "../TipAccordion";
var CreditAffects = function (_a) {
    var _b, _c, _d, _e;
    var enrolledAccountDetails = _a.enrolledAccountDetails;
    var reasons;
    if ((_c = (_b = enrolledAccountDetails === null || enrolledAccountDetails === void 0 ? void 0 : enrolledAccountDetails.scores) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.reasons) {
        reasons = (_e = (_d = enrolledAccountDetails === null || enrolledAccountDetails === void 0 ? void 0 : enrolledAccountDetails.scores) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.reasons;
    }
    if (reasons === undefined || reasons.length === 0) {
        return _jsx("div", {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(Inset, __assign({ left: "small" }, { children: _jsx(CreditAffectsTitle, __assign({ weight: "bold" }, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.headers.affect" }) })) })), _jsx(TipAccordion, { reasons: reasons }), _jsx(Stack, { size: "large" })] }));
};
export default CreditAffects;
